import React, { useMemo, useCallback } from 'react';
import { Marker, InfoBox } from '@react-google-maps/api';
import { useCookies } from 'react-cookie';
import { Button } from 'src/components';
import { useCreateModal, useEditData } from 'src/stores';
import { IconClose } from 'src/icons';
import { Indpin } from 'src/pages/Home/Home';
import styles from './IndpinMarker.module.scss';

type Props = {
  indpin: Indpin;
  activeIndpinId: number | null;
  i_activeMarker: (v: Indpin) => void;
  i_closeInfoBox: () => void;
};

// InfoBox オプション値
const infoBoxOptions = {
  disableAutoPan: true,
  alignBottom: true,
  maxWidth: 270,
  boxClass: styles.infobox,
};


/**
 * IndpinMarker コンポーネント
 * @returns React.ReactNode
 */
const IndpinMarker: React.FC<Props> = ({ indpin, activeIndpinId, i_activeMarker, i_closeInfoBox}) => {
  /**
   * 害獣座標をメモ化
   */
  const latlng = useMemo(() => new google.maps.LatLng({
    lat: Number(indpin.indpin_latitude),
    lng: Number(indpin.indpin_longitude),
  }), [indpin]);

  const [cookie] = useCookies();

  /**
   * InfoBox を表示するハンドラ
   * @example
   * <Marker onClick={handleMarkerClick} ... />
   */
  const handleMarkerClick = useCallback(() => {
    i_activeMarker(indpin);
  }, [i_activeMarker, indpin]);

/**
* 情報登録モーダルフラグ
*/
  const [createIndpinModalOpen] = useCreateModal(state => [state.createIndpinModalOpen]);

  /**
* 編集モーダル開閉時のデータ格納ストア
*/
  const [setEditIndpinData] = useEditData(state => [state.setEditIndpinData]);

  /**
 * 害獣情報修正モーダル を表示するハンドラ
 * @example
 * <Button onClick={handleEditModal} ... />
 */
  const handleEditModal = useCallback(() => {
    setEditIndpinData(indpin)
    createIndpinModalOpen()
  }, [indpin]);

//クリップボードにコピー関数
const copyToClipboard = useCallback(async () => {
  const url = window.location.origin +"/?corporate="+indpin.client_code+"&S_lat="+indpin.indpin_latitude+"&S_lon="+indpin.indpin_longitude
  await global.navigator.clipboard.writeText(url);
  alert("URLをコピー")
},[indpin]);

  return (
    <>
      <Marker position={latlng}
      label={indpin.indpin_label}
      onClick={handleMarkerClick}
      onRightClick={copyToClipboard}/*230915追記*/
      onDblClick={copyToClipboard}
      zIndex={indpin.indpin_id === activeIndpinId ? 100 : 0}
      />
      {indpin.indpin_id === activeIndpinId && (
        <InfoBox
          position={latlng}
          options={{
            ...infoBoxOptions,
            pixelOffset: new window.google.maps.Size(-135, -10),
          }}
        >
          <div className={styles.overview}>
            <button
              className={styles.closeButton}
              aria-label="詳細ボックスを閉じる"
              onClick={i_closeInfoBox}
            >
              <IconClose />
            </button>
            <ul>
              <li>{indpin.indpin_id && `ID: ${indpin.indpin_id}`}</li>
              <li>{indpin.indpin_label && `ラベル: ${indpin.indpin_label}`}</li>
              <li>{indpin.indpin_comment && `コメント: ${indpin.indpin_comment}`}</li>
            </ul>
            <div className={`${cookie?.verminData?.user_kind_id > 1 ? styles.row : styles.row2}`} id ="edit_button">
              <Button onClick={handleEditModal} disabled={!cookie?.verminData?.user_kind_id || cookie?.verminData?.user_kind_id == 1 || (cookie?.verminData?.user_kind_id == 2 && cookie?.verminData?.user_info_id != indpin.register_user_id) || indpin.client_code != cookie?.verminData?.client_code}>
                情報編集
              </Button>
            </div>
          </div>
        </InfoBox>
      )}
    </>
  );
};

export default React.memo(IndpinMarker);
